<template>
    <div>

        <form @submit="onSubmit">
            <ion-item>
                <ion-label position="stacked">Code</ion-label>
                <ion-input disabled :value="config.code"/>
            </ion-item>
            <ion-item>
                <ion-label position="stacked">Titel</ion-label>
                <ion-input disabled :value="config.title"/>
            </ion-item>
            <ion-item>
                <ion-label position="stacked">Beschreibung</ion-label>
                <ion-input disabled :value="config.description"/>
            </ion-item>
            <ion-item>
                <ion-label>Typ</ion-label>
                <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="config.type" @ionChange="config.type = $event.target.value">
                    <ion-select-option value="box">Box</ion-select-option>
                    <ion-select-option value="content">Content</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item v-if="config.type === 'content'">
                <ion-label>Content</ion-label>
                <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="config.foreign" @ionChange="config.foreign = $event.target.value">
                    <ion-select-option v-for="content in this.allContents" :key="content.id" v-bind:value="content.id">{{ content.title }}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item v-if="config.type === 'box'">
                <ion-label>Box oder Tab</ion-label>
                <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="config.foreign" @ionChange="config.foreign = $event.target.value">
                    <ion-select-option v-for="box in this.allBoxes" :key="box.id" v-bind:value="box.id">{{ box.title }}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item>
                <ion-label>Spalten</ion-label>
                <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="config.cols" @ionChange="config.cols = $event.target.value">
                    <ion-select-option v-for="col in this.cols" :key="col.id" v-bind:value="col.id">{{ col.title }}</ion-select-option>
                </ion-select>
            </ion-item>

            <a href="/#/config/list/" class="link-button">Abbrechen</a>
            <ion-button type="submit">Speichern</ion-button>
        </form>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'ConfigFields',
        props: [ 'id'],
        methods: {
            ...mapActions(["getConfig", "getContents", "getBoxes", "updateConfig"]),
            onSubmit(e){
                this.updateConfig(this.config);
                e.preventDefault();
                this.$router.push('/');
            },
        },
        data() {
            return {
                config: {
                },
                cols : [
                    {
                        id: '3',
                        title: '1 Spalte'
                    },
                    {
                        id: '6',
                        title: '2 Spalten'
                    },
                    {
                        id: '9',
                        title: '3 Spalten'
                    },
                    {
                        id: '12',
                        title: '4 Spalten'
                    }
                ]
            };
        },
        computed: {
            ...mapGetters(["editConfig", "allConfigTypes", "allContents", "allBoxes"]),
        },
        async created() {
             await this.getConfig(this.id);
             this.config = this.editConfig;
             await this.getContents();
             this.getBoxes();
        }

    }
</script>

<style scoped>

</style>